import { useState, useEffect } from "react";

import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/gymPlaceholder.svg";
import { get, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate, useLocation } from "react-router-dom";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const GymsCategoryListing = () => {
  document.title = "Gym Category Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({
    dateRange: false,
    byLocation: false,
    mostLoved: false,
  });
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);
  const [gymsData, setGymsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalId, setModalId] = useState("");
  const itemsPerPage = 6;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startSearchDate, setStartSearchDate] = useState("");
  const [endSearchDate, setEndSearchDate] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [selectedTags, setSelectedTags] = useState(
    type != null || type != undefined ? type : "By Tags"
  );

  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );
  const toggleDropdown = (gymId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [gymId]: !prevState[gymId],
    }));
  };

  const fetchGyms = async (page, searchQuery) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.gymCategory}/?page=${page}&limit=${itemsPerPage}&search=${searchQuery}`
      );
      setGymsData(Array.isArray(response.data?.data) ? response.data.data : []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching gyms data:", error);
      setGymsData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchGyms(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm, selectedTags]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const navigate = useNavigate();
  const handleSelectChange = async (action, gymId) => {
    if (action === "add") {
      navigate(`/add-passes?gymId=${gymId}`);
    } else if (action === "passList") {
      navigate(`/list-passes?gymId=${gymId}`);
    } else if (action === "addEquip") {
      navigate(`/add-equip?gymId=${gymId}`);
    } else if (action === "equipList") {
      navigate(`/equip-listing?gymId=${gymId}`);
    } else if (action === "modify") {
      navigate(`/edit-gyms/${gymId}`, { state: { gymId: gymId } });
    } else if (action === "gymDetails") {
      navigate(`/gym-details/:id`, { state: { gymId: gymId } });
    } else if (action === "business") {
      navigate(`/add-businessverification/:id`, { state: { gymId: gymId } });
    } else if (action === "listBank") {
      navigate(`/list-bank?gymId=${gymId}`);
    } else if (action === "addBank") {
      navigate(`/add-bank?gymId=${gymId}`);
    } else if (action === "delete") {
      console.log("Deleting gym with ID:", gymId);

      try {
        await del(`${endpoints.gymCategory}/${gymId}`);
        setGymsData((prevData) => prevData.filter((gym) => gym.id !== gymId));
        fetchGyms(currentPage, "");
        toast.success(`Gym Category  Deleted Successfully`, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } catch (error) {
        console.error("Error deleting gym:", error);
        alert("Failed to delete the gym.");
      }
    }
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    fetchGyms(currentPage, debouncedSearchTerm);
    setEndSearchDate("");
    setStartSearchDate("");
    setSelectedTags("By Tags");
    setSearchTerm("");
    setCurrentPage(1);
  };
  const handleClearFilters = () => {
    setSelectedTags("By Tags");
    setSearchTerm("");
    setCurrentPage(1);
  };
  useEffect(() => {
    if (startSearchDate != "" && endSearchDate != "") {
      fetchGyms(currentPage, debouncedSearchTerm);
    } else {
      fetchGyms(currentPage, debouncedSearchTerm);
    }
  }, [startSearchDate, endSearchDate]);
  function formatDate(date) {
    try {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date)
        .toLocaleDateString("en-CA", options)
        .replace(/\//g, "-");
    } catch (err) {
      console.error("Error", err);
    }
  }
  return (
    <div>
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4 ">
              <CardBody>
                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-center mb-3">
                  {/* Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Categories
                    </span>
                    <div
                      className="w-100 w-sm-auto mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{ borderRadius: "12px", height: "48px" }}
                    >
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Filters and Buttons Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-xs-0">
                    <Button
                      className="rounded-pill w-auto  w-xs-100"
                      style={{ minWidth: "120px" }}
                      onClick={() => {
                        navigate(`/add-category`);
                      }}
                    >
                      Add New
                    </Button>
                  </div>
                </div>
                <div
                  className="table-responsive hide-scrollbar"
                  style={{
                    height: gymsData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead className="fixed-row">
                      <tr
                        className="ff-sora font-size-14 fw-bold primary-black"
                        style={{
                          lineHeight: "16.8px",
                        }}
                      >
                        <th>Id</th>
                        <th>Title</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : gymsData?.length === 0 ? (
                        <></>
                      ) : (
                        gymsData.map((gym, index) => (
                          <tr
                            key={gym._id + index}
                            className="ff-sora fw-normal font-size-14 secondary-black"
                            style={{
                              lineHeight: "16.8px",
                            }}
                          >
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>{gym?.title}</td>

                            <td>
                              <div key={gym.id} className="gym-item rounded-2">
                                <Dropdown
                                  isOpen={dropdownOpen[gym.id]}
                                  toggle={() => toggleDropdown(gym.id)}
                                  direction="down"
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                    }}
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={() =>
                                        navigate(`/edit-category/${gym.id}`)
                                      }
                                    >
                                      Edit
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setModalOpen(true);
                                        setModalId(gym.id);
                                      }}
                                    >
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && gymsData?.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="text-center ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page, index) => (
                    <Button
                      key={index + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded-4"
      >
        <ModalHeader
          toggle={toggleModal}
          className="font-size-16 fw-medium ff-sora"
        >
          Confirm Deletion
        </ModalHeader>
        <ModalBody className="font-size-14 fw-normal ff-sora">
          Are you sure you want to delete this gym category?
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className=" rounded-pill"
            onClick={() => {
              toggleModal();
              handleSelectChange("delete", modalId);
            }}
          >
            Confirm
          </Button>
          <Button color="white" className="rounded-pill1" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default GymsCategoryListing;
